const customColors = {
  lightGrey: '#F1F3F5',
  darkBlue: '#0A46E4',
  blue80: 'rgba(22, 82, 240, 0.8)'
};
export { customColors as default };
//# sourceMappingURL=customColors.js.map
